import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ClientsState } from '../_reducers/clients.reducers';

const getClientsFeatureState = createFeatureSelector<ClientsState>('clients');
export const getClients = createSelector(
  getClientsFeatureState,
  (state: ClientsState) => state.clients
);

export const getClientDetails = createSelector(
  getClientsFeatureState,
  (state: ClientsState) => state.client
);

/**
 * Select operations
 */
export const getClientsOperations = createSelector(
  getClientsFeatureState,
  (state: ClientsState) => state.operations
);

/**
 * Select clients datatable
 */
 export const getClientsDatatable = createSelector(
  getClientsFeatureState,
  (state: ClientsState) => state.datatable
);

/**
 * Select error
 */
 export const getError = createSelector(
  getClientsFeatureState,
  (state: ClientsState) => state.error
);

